<script setup>
import { ref, onMounted } from 'vue'

const shrinkTitle = ref(null);
const shrinkElement = ref(null);
onMounted(() => {
  window.addEventListener('scroll', shrinkTitleOnScroll);
  window.addEventListener('scroll', shrinkElementOnScroll);
});

let selectedLanguage = ref('japanese')

const switchToJapanese = () => {
  if(selectedLanguage.value === 'english') {
    selectedLanguage.value = 'japanese'
  }
}
const switchToEnglish = () => {
  if(selectedLanguage.value === 'japanese') {
    selectedLanguage.value = 'english'
  }
}

const shrinkTitleOnScroll = () => {
  const element = shrinkTitle.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add('-show');
      window.removeEventListener('scroll', shrinkTitleOnScroll);
    }
  }
};
const shrinkElementOnScroll = () => {
  const element = shrinkElement.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add('-show');
      window.removeEventListener('scroll', shrinkElementOnScroll);
    }
  }
};

</script>

<template>
  <div class="profile" id="profile">
    <div class="background-content">
      <p class="background-left shrink-title -left" ref="shrinkTitle">PROFILE</p>
    </div>
    <div class="profile-contents shrink-element" ref="shrinkElement">
      <div class="head-top">
        <div class="toggle">
          <button
            @click="switchToJapanese"
            :class="selectedLanguage === 'japanese' ? '-selected' : ''"
          >日本語</button>
          <button
            @click="switchToEnglish"
            :class="selectedLanguage === 'english' ? '-selected' : ''"
          >English</button>
        </div>
      </div>
      <div class="text">
        <img class="portrait" src="../../assets/images/profile/profile.jpg" alt="profile">
        <transition name="lang-fade" mode="out-in">
          <div class="description -japanese" v-if="selectedLanguage === 'japanese'" key="ja">
            <p class="name-line">村木龍（むらき りゅう）</p>
            <p>
              クラリネット、マルチリード奏者。
            </p>
            <p>
              1999年、神奈川県横浜市出身。中学校吹奏楽部への入部をきっかけにクラリネットを始め、ジャズと出会う。大学進学後、早稲田大学モダンジャズ研究会、立教大学<span class="en">New Swingin' Herd</span>へ入部し、ライブ活動を開始。
            </p>
            <p>
              現在はベニーグッドマン・トリオのスタイルを踏襲した、クラリネット、ピアノ、ドラムによるスイングジャズ・バンド <span class="en">"Ryu Muraki Three"</span> のほか、リーダーバンドにて、またサポートメンバーとして首都圏ライブハウス、ダンスイベントを中心に演奏活動を行う。
            </p>
            <p>
              増圭介氏率いるジャズ吹奏楽団 <span class="en">"Wind Roots"</span> にてクラリネットを担当。クラリネット・ビッグバンド <span class="en">Black Pied Pipers</span>に参加。ジャズを主軸としつつ、クラシック分野の演奏にも力を入れる。
            </p>
            <p>
              第22回大阪国際音楽コンクール木管楽器部門 <span class="en">Age-U</span>入選。第41回浅草ジャズコンテストバンド部門銀賞(<span class="en">Ryu Muraki Three</span>)、ベストプレーヤー賞受賞。
            </p>
          </div>
          <div class="description -english" v-else key="en">
            <p class="name-line">Ryu Muraki</p>
            <p>
              Clarinetist and multi-reed player.
            </p>
            <p>
              Born in Yokohama, Kanagawa Prefecture, in 1999. He began playing the clarinet after joining his junior high
              school's wind ensemble, which is where he was first introduced to jazz. After entering college, he joined the
              Waseda University Modern Jazz Society and the Rikkyo University New Swingin' Herd, and began performing live.
            </p>
            <p>
              Currently, in addition to "Ryu Muraki Three"—a swing jazz band featuring clarinet, piano, and drums that
              follows the style of the Benny Goodman Trio—he performs primarily at live houses and dance events in the
              Tokyo metropolitan area, both as the leader of his own band and as a session musician.
            </p>
            <p>
              He plays clarinet in the jazz wind orchestra "Wind Roots," led by Keisuke Masu. He is a member of the
              clarinet big band "Black Pied Pipers." While focusing primarily on jazz, he also devotes significant effort
              to performing classical music.
            </p>
            <p>
              He was a finalist in the Age-U category of the Woodwind Division at the 22nd Osaka International Music
              Competition. He won the Silver Prize in the Band Division (Ryu Muraki Three) and the Best Player Award at
              the 41st Asakusa Jazz Contest.
            </p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>


<style lang="scss" src="./style.scss" scoped></style>
